import type { TAnswerInline, TAnswerListItem } from 'shared/types/faq';

const isNonEmptyInline = (part: TAnswerInline): boolean => {
  if (part.type === 'link') {
    return Boolean(part.value.trim() && part.url.trim());
  }

  return Boolean(part.value.trim());
};

/** Отфильтровывает пустые inline-части пункта списка. */
export const normalizeListItem = (item: TAnswerListItem): TAnswerListItem => {
  return item.filter(isNonEmptyInline);
};

/** Убирает пустые пункты и пустые inline-части. */
export const normalizeListItems = (items: TAnswerListItem[]): TAnswerListItem[] => {
  return items.map(normalizeListItem).filter(item => item.length > 0);
};
